import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { Alert } from '../../core/models/alert.model';
import { MatTabsModule } from '@angular/material/tabs';
import { GeneralComponent } from '../general/general.component';
import { Constants } from '../../shared/utils/constants';
import { UpdateRecordService } from '../../core/services/update-record.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { UpdateRecord } from '../../core/models/update-record.model';
import { ModalComponent } from '../modal/modal.component';
import { PdfPreviewModalComponent } from '../pdf-preview-modal/pdf-preview-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ShiftClosureService } from '../../core/services/shift-closure.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { lastValueFrom, forkJoin, firstValueFrom } from 'rxjs';
import { ShiftClosure } from '../../core/models/shift-closure.model';
import { UpdateRecordSearchDTO } from '../../core/models/search-filter.model';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-daily-shift',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
    MatTableModule,
    MatTabsModule,
    GeneralComponent,
    ReactiveFormsModule,
    MatDialogModule,
    ConfirmPopupComponent,
    MatSnackBarModule,
    PdfPreviewModalComponent
  ],
  templateUrl: './daily-shift.component.html',
  styleUrl: './daily-shift.component.scss',
})
export class DailyShiftComponent implements OnInit {
  alerts: Alert[] = [];
  shiftUpdates: any[] = [];
  shiftUpdatesByArea: any[] = [];
  showClonePopup = false;
  recordToClone: any | null = null;
  showConfirmPopup = false;

  generalTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosureDaily', isCheckbox: true, showSelectAll: true, width: '100px' },
    //  { header: 'Área', field: 'updateArea' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Novedad', field: 'novedad', width: '60%' },
    // { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  reportedBreakdownNoticeTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosureDaily', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Prioridad', field: 'prioridad', width: '100px' },
    { header: '¿Qué está mal?', field: 'que_esta_mal', width: '15%' },
    { header: '¿Qué tiene de malo?', field: 'que_tiene_de_malo', width: '15%' },
    { header: 'Debería', field: 'deberia', width: '15%' },
    // { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  workOrderTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosureDaily', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'N° Orden de Trabajo', field: 'n_orden', width: '140px' },
    { header: 'Fecha', field: 'fecha', isDate: true, width: '100px' },
    { header: 'Hora Inicio', field: 'hora_inicio', width: '100px' },
    { header: 'Hora Término', field: 'hora_termino', width: '100px' },
    { header: 'Hora Permiso Otorgado', field: 'hora_permiso', width: '150px' },
    { header: 'En Ejecución', field: 'en_ejecucion', width: '100px' },
    { header: 'Comentarios', field: 'comentarios', width: '30%' },
    // { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  outOfServiceTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosureDaily', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Novedad', field: 'ingrese_novedad', width: '60%' },
    // { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  shiftUpdatesTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosureDaily', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Hora', field: 'hora', width: '100px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Tipo', field: 'tipo_novedad', width: '120px' },
    { header: 'Novedad', field: 'detalleNovedad', width: '50%' },
    { header: 'Fecha', field: 'fecha', isDate: true, width: '100px' },
  ];

  shiftUpdatesTablePersonalColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosureDaily', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Hora', field: 'hora', width: '100px' },
    //  { header: 'Responsable', field: 'responsable' },
    //  { header: 'Tipo', field: 'tipo_novedad' },
    { header: 'Novedad', field: 'detalleNovedad', width: '60%' },
    { header: 'Fecha', field: 'fecha', isDate: true, width: '100px' },
  ];

  flattenedData: { [key: string]: any[] } = {
    [Constants.NOVEDADES]: [],
    [Constants.AVISO_AVERIAS]: [],
    [Constants.OT_EJECUTADAS]: [],
    [Constants.FUERA_SERVICIO]: [],
    [Constants.SEGURIDAD]: [],
    [Constants.PERSONAL]: [],
  };

  // Nueva propiedad para datos agrupados por área
  groupedGeneralData: { [areaName: string]: any[] } = {};
  areaNames: string[] = [];

  // Datos filtrados para las tablas específicas
  seguridadCalidadMedioAmbiente: any[] = [];
  personalData: any[] = [];
  actualShiftClosure: ShiftClosure | null = null

  constructor(
    private updateRecordService: UpdateRecordService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private shiftClosureService: ShiftClosureService,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) { }

  async ngOnInit(): Promise<void> {

    this.loadAndFilterByShiftSupervisor()

    //this.loadData();
    // this.loadDataByType(Constants.NOVEDADES);//10
    // this.loadDataByType(Constants.AVISO_AVERIAS);//7
    // this.loadDataByType(Constants.OT_EJECUTADAS);//8
    // this.loadDataByType(Constants.FUERA_SERVICIO);//9
    // this.loadDataByType(Constants.SEGURIDAD);//1
    // this.loadDataByType(Constants.PERSONAL);//3
  }

  private async loadAndFilterByShiftSupervisor() {

    //Guard Clause
    const shiftId = await this.getOpenDailyShift()
    if (!shiftId) return

    const userId = this.authService.getUserId();

    const filterSecurityType: UpdateRecordSearchDTO = {
      type: 'seguridad',
      areas: [Constants.GENERAL],
      shiftClosureId: shiftId
    }
    this.seguridadCalidadMedioAmbiente = await this.getPreviousShiftClosureForGeneralNewsSection(filterSecurityType) || []

    const filterPesonalType: UpdateRecordSearchDTO = {
      type: 'personal',
      areas: [Constants.GENERAL],
      shiftClosureId: shiftId
    }
    this.personalData = await this.getPreviousShiftClosureForGeneralNewsSection(filterPesonalType) || []

    const searchFilterShiftSupervisor: UpdateRecordSearchDTO = {
      type: '',
      areas: [],
      shiftClosureId: shiftId,
      //TODO: incorporar filtro segun la llamada
      // stateFilters: {
      //   isClosed: true,
      //   isMarkedForClosure: false
      // }
    }

    searchFilterShiftSupervisor.areas = [
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS
    ]

    const types: string[] = [
      Constants.NOVEDADES,
      Constants.AVISO_AVERIAS,
      Constants.OT_EJECUTADAS,
      Constants.FUERA_SERVICIO,
      Constants.SEGURIDAD,
      Constants.PERSONAL
    ]

    types.forEach(type => {
      const filter = { ...searchFilterShiftSupervisor, type }
      this.getByUpdateRecordSearch(filter)
    })

  }

  private async getPreviousShiftClosureForGeneralNewsSection(filters: UpdateRecordSearchDTO): Promise<UpdateRecord[] | null> {
    try {
      const response: UpdateRecord[] = await firstValueFrom(this.updateRecordService.getUpdateRecordsPost(filters))
      const flattened = this.flattenData(response)
      return flattened
    } catch (err) {
      console.error('error en getPreviousShiftClosure', err)
      return null
    }
  }

  private async getByUpdateRecordSearch(filter: UpdateRecordSearchDTO) {
    const type = filter.type
    try {
      const response = await firstValueFrom(this.updateRecordService.getUpdateRecordsPost(filter))
      const flattened = this.flattenData(response);
      this.flattenedData[type] = flattened.length ? flattened : [];
      if (type === Constants.NOVEDADES) this.groupDataByArea(flattened)

    } catch (error) {
      console.error('error buscarPorPOST:', error)
    }

  }

  private async getOpenDailyShift(): Promise<number | null> {
    try {
      const shiftId: number = await firstValueFrom(this.shiftClosureService.getOpenDailyShift())
      return shiftId ? shiftId : null
    } catch (error: any) {
      if (error?.status === 404) {
        return null;
      } else {
        //redirigir a vista enterior
        return null;
      }
    }
  }


  loadData(): void {
    const areasGeneral = [Constants.GENERAL];
    const areasByArea = [
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS,
    ];

    this.loadRecordsByArea(areasGeneral, 'shiftUpdates');
    // this.loadRecordsByArea(areasByArea, 'shiftUpdatesByArea');
  }

  loadDataByType(type: string): void {

    // Define las áreas que deseas pasar al servicio
    const areas: string[] = [
      //Constants.GENERAL,
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS,
    ];
    const isClosed = false;
    const isMarkedForClosure = undefined;
    const isMarkedForPreClosure = undefined;

    this.updateRecordService
      .getUpdateRecordsByTypeAndAreas(type, areas, isClosed, isMarkedForClosure, isMarkedForPreClosure)
      .subscribe({
        next: (updates: UpdateRecord[]) => {
          const flattened = this.flattenData(updates);
          this.flattenedData[type] = flattened.length ? flattened : [];

          // Si es el tipo "novedades", agrupar por área
          if (type === Constants.NOVEDADES) {
            this.groupDataByArea(flattened);
          }
        },
        error: error => {
          if (error.status === 404) {
            this.flattenedData[type] = [];
            if (type === Constants.NOVEDADES) {
              // Inicializar todas las áreas con arrays vacíos cuando no hay datos
              this.initializeAllAreas();
            }
          } else {
            console.error(`Error al cargar los datos para el tipo ${type}:`, error);
            this.flattenedData[type] = [];
          }
        },
      });
  }

  private loadRecordsByArea(areas: string[], target: 'shiftUpdates' | 'shiftUpdatesByArea'): void {
    this.updateRecordService.getUpdateRecordsByAreas(areas, false).subscribe({
      next: (updates: UpdateRecord[]) => {
        const flattened = this.flattenData(updates);
        this[target] = flattened.length ? flattened : [];

        // Filtrar datos para las tablas específicas
        this.filterDataByType(flattened);
      },
      error: error => {
        if (error.status === 404) {
          this[target] = [];
          this.seguridadCalidadMedioAmbiente = [];
          this.personalData = [];
        } else {
          console.error(`Error al cargar los datos para las áreas ${areas}:`, error);
          this[target] = [];
        }
      },
      complete: () => {
        this.cdr.detectChanges();
      },
    });
  }

  // Determina la marca de cierre a mostrar según área del registro
  private getRoleSpecificClosureMark(update: UpdateRecord): boolean {
    const u: any = update as any;
    const areaCode = update.updateArea?.code?.toLowerCase?.() ?? '';
    if (areaCode === 'dcs') {
      return (u.isMarkedForClosureDCS ?? u.isMarkedForClosureDcs ?? update.isMarkedForClosure) as boolean;
    }
    if (areaCode === 'cloruro_ferrico' || areaCode === 'ferrico') {
      return (u.isMarkedForClosureFerrico ?? update.isMarkedForClosure) as boolean;
    }
    return update.isMarkedForClosure;
  }

  // Determina la marca de cierre diario a mostrar: usar isMarkedForClosureDaily
  private getClosureDailyMark(update: UpdateRecord): boolean {
    const rec: any = update as any;
    return Boolean(rec.isMarkedForClosureDaily);
  }

  flattenData(updates: UpdateRecord[]): any[] {
    return updates.flatMap(update => {
      if (update.id == 303) {
        console.log("update: ", update);
      }
      const elements = update.updateElements;
      const getElementValue = (label: string): string =>
        elements.find(el => el.label === label)?.updateValues?.[0]?.value || '';

      const hora = getElementValue('Hora');
      const novedad = getElementValue('Novedad');
      const tipoNovedad = getElementValue('Tipo de Novedad');
      const prioridad = getElementValue('Prioridad');
      const queEstaMal = getElementValue('¿Qué está mal?');
      const queTieneDeMalo = getElementValue('¿Qué tiene de malo?');
      const deberia = getElementValue('Debería');
      const nOrden = getElementValue('N° Orden de Trabajo');
      const horaInicio = getElementValue('Hora Inicio');
      const horaTermino = getElementValue('Hora Término');
      const horaPermiso = getElementValue('Hora Permiso Otorgada');
      const enEjecucion = getElementValue('En Ejecución');
      const comentarios = getElementValue('Comentarios');
      const horaFueraServicio = getElementValue('Hora Fuera de Servicio');
      const ingreseNovedad = getElementValue('Ingrese Novedad');


      // Solo los valores sin los labels
      const detalleNovedad = elements
        .filter(el => el.label !== 'Hora' && el.label !== 'Tipo de Novedad')
        .map(el => el.updateValues?.map(val => val.value).join(', ') || '')
        .filter(txt => txt.trim() !== '')
        .join(', ');

      return {
        id: update.id,
        hora,
        hora_inicio: horaInicio,
        hora_termino: horaTermino,
        hora_permiso: horaPermiso,
        hora_fuera_servicio: horaFueraServicio,
        ingrese_novedad: ingreseNovedad,
        en_ejecucion: enEjecucion,
        n_orden: nOrden,
        prioridad,
        que_esta_mal: queEstaMal,
        que_tiene_de_malo: queTieneDeMalo,
        deberia,
        responsable: elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]?.createdUser?.username || '',
        tipo_novedad: tipoNovedad ? tipoNovedad : update.updateType?.name,
        tipo: update.updateType?.name,
        area: update.updateArea?.name,
        updateArea: update.updateArea?.name,
        novedad: novedad,
        detalleNovedad,
        comentarios,
        fecha: elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]?.createdUtc || '',
        updateElements: elements,
        updateType: update.updateType,
        // Mantener compatibilidad pero mostrar/usar cierre diario en UI
        isMarkedForClosure: this.getRoleSpecificClosureMark(update),
        isMarkedForPreClosure: (update as any)?.isMarkedForPreClosure,
        isMarkedForClosureDaily: this.getClosureDailyMark(update),
        isCloned: update.isCloned,

      };
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  viewUpdateRecord(updateRecord: UpdateRecord): void {
    console.log("updateRecord: ", updateRecord);
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar el objeto directamente
        readOnly: true, // Abrir en modo solo lectura
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  async shiftClosure() {
    // Caso especial: para daily-shift el turno abierto se consulta siempre con userId=1 (usuario administrador)
    const response = await lastValueFrom(
      this.shiftClosureService.getOpenShiftByTypeForUser(Constants.TURNO_DIARIO, 1)
    );
    const shiftClosureId = response;
    if (shiftClosureId === undefined || shiftClosureId === null) {
      console.error('No se encontró un turno abierto.');
      return;
    }

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        type: Constants.TIPO_CIERRE_TURNO,
        area: Constants.AREA_CIERRE_TURNO_DIARIO,
        shiftClosureId: shiftClosureId,
        skipPreview: true, // Saltar paso de previsualización PDF
        closureMode: 'daily', // Especificar modo de cierre diario
        closeUpdateRecord: false // No cerrar registros al finalizar cierre
      },
      width: '900px',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadData();
      this.loadDataByType(Constants.NOVEDADES);
      this.loadDataByType(Constants.AVISO_AVERIAS);
      this.loadDataByType(Constants.OT_EJECUTADAS);
      this.loadDataByType(Constants.FUERA_SERVICIO);
      this.loadDataByType(Constants.SEGURIDAD);
      this.loadDataByType(Constants.PERSONAL);
    });
  }

  async openPdfPreview() {
    try {
      // Primero obtenemos el ID del turno abierto actual
      const response = await lastValueFrom(
        this.shiftClosureService.getOpenShiftByType(Constants.TURNO_DIARIO)
      );
      const shiftClosureId = response;

      if (shiftClosureId === undefined || shiftClosureId === null) {
        this.snackBar.open('No se encontró un turno abierto para generar la previsualización.', 'Cerrar', { duration: 5000 });
        return;
      }

      // Cargar primero los datos actuales para no perder los valores
      const currentFormValues = await this.getCurrentFormValues(shiftClosureId);

      // Abrir el modal con el flujo de stepper para cierre de turno
      const dialogRef = this.dialog.open(ModalComponent, {
        data: {
          type: Constants.TIPO_CIERRE_TURNO,
          area: Constants.AREA_CIERRE_TURNO_DIARIO,
          readOnly: false,
          shiftClosureId: shiftClosureId,
          isPreviewMode: true, // Modo previsualización automática
          currentFormValues: currentFormValues // Pasar los valores actuales del formulario
        },
        minWidth: '50%',
        minHeight: '20%',
        maxWidth: '1200px',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.success && !result?.previewOpened) {
          this.loadData(); // Solo recargar datos si fue un cierre completo, no solo previsualización
        }
      });
    } catch (error) {
      console.error('Error al abrir la previsualización del PDF:', error);
      this.snackBar.open('Error al abrir la previsualización del PDF.', 'Cerrar', { duration: 5000 });
    }
  }

  onCheckboxChange(isMarked: boolean, updateRecordId: number): void {
    // Daily-shift: actualizar la marca de cierre diario
    this.updateRecordService.updateMarkForClosureDaily(updateRecordId, isMarked).subscribe({
      next: () => {
        console.log('Estado actualizado correctamente.');
      },
      error: (error) => {
        console.error('Error al actualizar el estado:', error);
      },
    });
  }

  onSelectAllChange(event: { checked: boolean; type: string; visibleData?: any[] }): void {
    const checked = event.checked;
    const tableType = event.type;
    let targetData: any[] = [];

    // Si se proporcionan los datos visibles, usar esos. Si no, usar todos los datos.
    if (event.visibleData && event.visibleData.length > 0) {
      targetData = event.visibleData;
    } else {
      // Determinar qué datos usar basándose en el tipo de tabla (comportamiento anterior)
      switch (tableType) {
        case 'seguridad':
          targetData = this.seguridadCalidadMedioAmbiente;
          break;
        case 'personal':
          targetData = this.personalData;
          break;
        case 'aviso_averias':
          targetData = this.flattenedData['aviso_averias'];
          break;
        case 'o_t_ejecutadas':
          targetData = this.flattenedData['o_t_ejecutadas'];
          break;
        case 'fuera_servicio':
          targetData = this.flattenedData['fuera_servicio'];
          break;
        default:
          // Para las tablas de área (groupedGeneralData)
          targetData = this.groupedGeneralData[tableType] || [];
          break;
      }
    }

    if (!targetData || targetData.length === 0) {
      console.warn(`No hay datos para la tabla: ${tableType}`);
      return;
    }

    // Filtrar solo los elementos que realmente necesitan cambio de estado
    const itemsToUpdate = targetData.filter(record =>
      record && record.id && record.isMarkedForClosureDaily !== checked
    );

    if (itemsToUpdate.length === 0) {
      console.log('Todos los elementos visibles ya tienen el estado deseado.');
      return;
    }

    // Crear llamadas API solo para los registros que necesitan cambio
    const apiCalls = itemsToUpdate.map(record =>
      this.updateRecordService.updateMarkForClosureDaily(record.id, checked)
    );

    // Guardar el estado actual de los elementos que van a cambiar
    const previousStates = itemsToUpdate.map(record => ({
      id: record.id,
      isMarkedForClosureDaily: record.isMarkedForClosureDaily
    }));

    // Actualizar el estado UI inmediatamente solo en elementos que van a cambiar
    itemsToUpdate.forEach(record => {
      record.isMarkedForClosureDaily = checked;
    });

    // Ejecutar todas las llamadas API en paralelo
    forkJoin(apiCalls).subscribe({
      next: (responses) => {
        console.log(`Todos los registros de ${tableType} actualizados correctamente:`, responses);
        this.snackBar.open(
          `${itemsToUpdate.length} registros ${checked ? 'seleccionados' : 'deseleccionados'} correctamente`,
          'Cerrar',
          { duration: 3000 }
        );
      },
      error: (error) => {
        console.error(`Error al actualizar los registros de ${tableType}:`, error);

        // Rollback: restaurar el estado anterior solo en los elementos que intentamos cambiar
        itemsToUpdate.forEach(record => {
          const previousState = previousStates.find(state => state.id === record.id);
          if (previousState) {
            record.isMarkedForClosureDaily = previousState.isMarkedForClosureDaily;
          }
        });

        this.snackBar.open(
          'Error al actualizar los registros. Se han revertido los cambios.',
          'Cerrar',
          { duration: 5000 }
        );

        // Forzar detección de cambios para actualizar la UI
        this.cdr.detectChanges();
      }
    });
  }

  openCloneConfirmation(record: any): void {
    this.recordToClone = record;
    this.showClonePopup = true;
  }

  closeClonePopup(): void {
    this.showClonePopup = false;
    this.recordToClone = null;
  }

  confirmClone(): void {
    if (!this.recordToClone) {
      console.error('No hay registro para clonar.');
      return;
    }

    this.updateRecordService.cloneUpdateRecord(this.recordToClone.id).subscribe({
      next: clonedRecord => {
        console.log('Registro clonado exitosamente:', clonedRecord);
        this.ngOnInit();
        this.closeClonePopup();
      },
      error: err => {
        console.error('Error al clonar el registro:', err);
      },
    });

    console.log("shiftUpdatesByArea: ", this.shiftUpdatesByArea);
  }

  editUpdateRecord(updateRecord: any): void {
    if (!updateRecord.updateElements) {
      console.error('El objeto no tiene elementos de actualización:', updateRecord);
      return;
    }

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar los datos del registro
        readOnly: false, // Permitir edición
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
      if (result?.success) {
        console.log('Edición realizada con éxito. Actualizando datos...');
        this.ngOnInit();
      }
    });
  }

  deleteUpdateRecord(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: '¿Estás seguro de que deseas eliminar este registro?' },
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.updateRecordService.deleteUpdateRecord(id).subscribe({
          next: () => {
            console.log(`Registro con ID ${id} eliminado correctamente.`);
            this.ngOnInit();
          },
          error: error => {
            console.error(`Error al eliminar el registro con ID ${id}:`, error);
          },
        });
      }
    });
  }

  openConfirmPopup(): void {
    this.showConfirmPopup = true; // Mostrar el popup de confirmación
  }

  closeConfirmPopup(): void {
    this.showConfirmPopup = false; // Ocultar el popup de confirmación
  }

  confirmStartShift(): void {
    this.closeConfirmPopup(); // Cerrar el popup antes de iniciar el turno

    const payload = { shiftClosureType: Constants.TURNO_DIARIO };
    // Para daily-shift, forzar userId = 1 (administrador)
    this.shiftClosureService.startShift(payload, 1).subscribe({
      next: (response) => {
        this.snackBar.open('Turno iniciado exitosamente.', 'Cerrar', { duration: 3000 });
        console.log('Turno iniciado:', response);
      },
      error: (err) => {
        console.error('Error al iniciar el turno:', err);
        this.snackBar.open(
          err?.error || 'Ocurrió un error al iniciar el turno.',
          'Cerrar',
          { duration: 3000 }
        );
      },
    });
  }

  /**
   * Obtiene los valores actuales del formulario para el turno diario especificado
   */
  async getCurrentFormValues(shiftClosureId: number): Promise<any> {
    try {
      // Obtener los datos actuales del registro
      const records = await lastValueFrom(
        this.updateRecordService.getUpdateRecordsByShiftClosureAndArea(
          shiftClosureId,
          [Constants.AREA_CIERRE_TURNO_DIARIO]
        )
      );

      if (records && records.length > 0) {
        // Transformar los datos a un formato que pueda ser utilizado por el formulario
        const formValues: { [key: string]: any } = {};

        // Procesar cada elemento del registro y guardar sus valores
        records[0].updateElements.forEach(element => {
          if (element.updateValues && element.updateValues.length > 0) {
            const value = element.updateValues[0].value;
            // Solo guardar valores que no sean '0'
            if (value !== '0' && value !== '') {
              formValues[element.id.toString()] = value;
              console.log(`Saving daily shift form value for field ${element.id}: ${value}`);
            }
          }
        });

        return formValues;
      }

      return {}; // Retornar objeto vacío si no hay datos
    } catch (error) {
      console.error('Error al obtener los valores actuales del formulario del turno diario:', error);
      return {};
    }
  }

  // Método para agrupar datos por área
  groupDataByArea(data: any[]): void {
    // Mapeo de códigos de área a nombres para mostrar
    const areaDisplayNames: { [key: string]: string } = {
      [Constants.CLORURO_FERRICO]: 'Cloruro Férrico',
      [Constants.SALMUERA_I]: 'Salmuera I',
      [Constants.SALMUERA_II]: 'Salmuera II',
      [Constants.COMPRESION]: 'Compresión',
      [Constants.ELECTROLIZADORES]: 'Electrolizadores',
      [Constants.SUBESTACION]: 'Subestación',
      [Constants.MOVIMIENTO_PRODUCTO]: 'Movimiento de productos',
      [Constants.DCS]: 'DCS',
      'Personal': 'Personal',
      'Seguridad / Calidad / Medio Ambiente': 'Seguridad / Calidad / Medio Ambiente'
    };

    // Función para normalizar texto (quitar tildes, convertir a minúsculas, quitar espacios extra)
    const normalizeText = (text: string): string => {
      return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Quitar tildes
        .replace(/\s+/g, ' ')
        .trim();
    };

    // Mapeo completo de todas las posibles variaciones de nombres de área a nombres finales
    const createAreaMapping = (): { [key: string]: string } => {
      const mapping: { [key: string]: string } = {};

      // Cloruro Férrico - todas las variaciones posibles
      const cloruroVariations = [
        'Cloruro Férrico', 'Cloruro Ferrico', 'cloruro férrico', 'cloruro ferrico',
        'CLORURO FÉRRICO', 'CLORURO FERRICO', 'Cloruro_Ferrico', 'cloruro_ferrico'
      ];
      cloruroVariations.forEach(v => mapping[normalizeText(v)] = 'Cloruro Férrico');

      // Salmuera I - todas las variaciones posibles
      const salmueraIVariations = [
        'Salmuera I', 'salmuera i', 'SALMUERA I', 'Salmuera_I', 'salmuera_i',
        'Salmuera 1', 'salmuera 1', 'SALMUERA 1'
      ];
      salmueraIVariations.forEach(v => mapping[normalizeText(v)] = 'Salmuera I');

      // Salmuera II - todas las variaciones posibles  
      const salmueraIIVariations = [
        'Salmuera II', 'salmuera ii', 'SALMUERA II', 'Salmuera_II', 'salmuera_ii',
        'Salmuera 2', 'salmuera 2', 'SALMUERA 2'
      ];
      salmueraIIVariations.forEach(v => mapping[normalizeText(v)] = 'Salmuera II');

      // Compresión - todas las variaciones posibles
      const compresionVariations = [
        'Compresión', 'Compresion', 'compresión', 'compresion',
        'COMPRESIÓN', 'COMPRESION', 'Compresion', 'compresion'
      ];
      compresionVariations.forEach(v => mapping[normalizeText(v)] = 'Compresión');

      // Electrolizadores - todas las variaciones posibles
      const electrolizadoresVariations = [
        'Electrolizadores', 'electrolizadores', 'ELECTROLIZADORES',
        'Electrolizador', 'electrolizador', 'ELECTROLIZADOR'
      ];
      electrolizadoresVariations.forEach(v => mapping[normalizeText(v)] = 'Electrolizadores');

      // Subestación - todas las variaciones posibles
      const subestacionVariations = [
        'Subestación', 'Subestacion', 'subestación', 'subestacion',
        'SUBESTACIÓN', 'SUBESTACION'
      ];
      subestacionVariations.forEach(v => mapping[normalizeText(v)] = 'Subestación');

      // Movimiento de productos - todas las variaciones posibles
      const movimientoVariations = [
        'Movimiento de productos', 'movimiento de productos', 'MOVIMIENTO DE PRODUCTOS',
        'Movimiento de Productos', 'Movimiento_de_productos', 'movimiento_de_productos',
        'Movimiento', 'movimiento', 'MOVIMIENTO'
      ];
      movimientoVariations.forEach(v => mapping[normalizeText(v)] = 'Movimiento de productos');

      // DCS - todas las variaciones posibles
      const dcsVariations = ['DCS', 'dcs', 'Dcs'];
      dcsVariations.forEach(v => mapping[normalizeText(v)] = 'DCS');

      // Personal - todas las variaciones posibles
      const personalVariations = ['Personal', 'personal', 'PERSONAL'];
      personalVariations.forEach(v => mapping[normalizeText(v)] = 'Personal');

      // General / Seguridad / Calidad / Medio Ambiente - todas las variaciones posibles
      const generalVariations = [
        'General', 'general', 'GENERAL',
        'Seguridad / Calidad / Medio Ambiente', 'seguridad / calidad / medio ambiente',
        'Seguridad', 'seguridad', 'SEGURIDAD',
        'Calidad', 'calidad', 'CALIDAD',
        'Medio Ambiente', 'medio ambiente', 'MEDIO AMBIENTE'
      ];
      generalVariations.forEach(v => mapping[normalizeText(v)] = 'Seguridad / Calidad / Medio Ambiente');

      return mapping;
    };

    const areaMapping = createAreaMapping();

    // Inicializar todas las áreas con arrays vacíos
    this.groupedGeneralData = {};
    Object.values(areaDisplayNames).forEach(displayName => {
      this.groupedGeneralData[displayName] = [];
    });

    // Agrupar los datos existentes
    data.forEach(item => {
      let areaKey = item.updateArea || 'Sin área';
      console.log('Procesando item con área:', areaKey, 'Item completo:', item);

      // Normalizar el nombre del área para comparación
      const normalizedAreaKey = normalizeText(areaKey);

      // Buscar el mapeo en nuestra tabla de mapeo completa
      let displayName = areaMapping[normalizedAreaKey];

      // Si no se encuentra una coincidencia exacta, usar valor por defecto
      if (!displayName) {
        console.warn('Área no reconocida:', areaKey, 'normalizada como:', normalizedAreaKey);
        displayName = 'Seguridad / Calidad / Medio Ambiente'; // Área por defecto
      }

      console.log('Área mapeada:', areaKey, '->', displayName);

      if (!this.groupedGeneralData[displayName]) {
        this.groupedGeneralData[displayName] = [];
      }

      this.groupedGeneralData[displayName].push(item);
    });

    // Definir el orden de las áreas (Personal y Seguridad al final)
    this.areaNames = Object.keys(areaDisplayNames).filter(key => key !== 'Personal' && key !== 'Seguridad / Calidad / Medio Ambiente')
      .map(key => areaDisplayNames[key])
      .sort((a, b) => a.localeCompare(b));

    console.log('Datos agrupados por área:', this.groupedGeneralData);
    console.log('Nombres de áreas:', this.areaNames);
  }

  // Método para inicializar todas las áreas cuando no hay datos
  initializeAllAreas(): void {
    const areaDisplayNames = [
      'Cloruro Férrico',
      'Salmuera I',
      'Salmuera II',
      'Compresión',
      'Electrolizadores',
      'Subestación',
      'Movimiento de productos',
      'DCS',
      'Seguridad / Calidad / Medio Ambiente',
      'Personal'
    ];

    this.groupedGeneralData = {};
    areaDisplayNames.forEach(displayName => {
      this.groupedGeneralData[displayName] = [];
    });

    // Definir el orden de las áreas (Personal y Seguridad al final)
    this.areaNames = areaDisplayNames.filter(name => name !== 'Personal' && name !== 'Seguridad / Calidad / Medio Ambiente')
      .sort((a, b) => a.localeCompare(b));

    // Agregar Personal y Seguridad al final
    this.areaNames.push('Seguridad / Calidad / Medio Ambiente');
    this.areaNames.push('Personal');
  }

  // Método para filtrar datos según el tipo de actualización
  filterDataByType(data: any[]): void {
    this.seguridadCalidadMedioAmbiente = data.filter(item => {
      const tipoUpdate = item.updateType?.name || item.tipo || item.tipo_novedad || '';
      return tipoUpdate === 'Seguridad / Calidad / Medio ambiente' ||
        tipoUpdate.toLowerCase().includes('seguridad') ||
        tipoUpdate.toLowerCase().includes('calidad') ||
        tipoUpdate.toLowerCase().includes('medio ambiente');
    });

    this.personalData = data.filter(item => {
      const tipoUpdate = item.updateType?.name || item.tipo || item.tipo_novedad || '';
      return tipoUpdate === 'Personal' ||
        tipoUpdate.toLowerCase().includes('personal');
    });
  }


}
